import { IS_CLIENT } from 'constants'
import {
	createBrowserHistory,
	createMemoryHistory,
} from 'history'

export const history = IS_CLIENT
	? createBrowserHistory()
	: createMemoryHistory()
